export default __webpack_public_path__ + "static/MediaContentOne-1d73d7eeca26d0a2b918e015205384f4.webp";